// extracted by mini-css-extract-plugin
var _1 = "styles-module__tooltip___PlkqZ";
export { _1 as "tooltip" }
